import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { impersonateClient, reloadUserInfo } from '../actions/auth.actions';
import { AuthManagedStorageService } from '../auth-managed-storage.service';
import { AuthService } from '../auth.service';

@Injectable()
export class ImpersonateClientEffects {
  constructor(
    private actions$: Actions,
    private storage: AuthManagedStorageService,
    private authService: AuthService
  ) {}

  setImpersonateClient$ = createEffect(
    () =>
      this.actions$
        .pipe(ofType(impersonateClient))
        .pipe(tap(action => this.storage.updateStateItem('impersonatedClientId', action.impersonatedClientId))),
    { dispatch: false }
  );

  triggerReloadUserInfo$ = this.authService.config.reloadAppUserInfoOnClientImpersonation
    ? createEffect(() => this.actions$.pipe(ofType(impersonateClient)).pipe(map(reloadUserInfo)))
    : EMPTY;
}
